/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Blog_PostsInputs */

const en_label_blog_posts = /** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updates & Feed`)
};

const es_label_blog_posts = /** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizaciones y Feed`)
};

const fr_label_blog_posts = /** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mises à jour et Flux`)
};

const de_label_blog_posts = /** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updates & Feed`)
};

const id_label_blog_posts = /** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembaruan & Feed`)
};

/** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */
const ja_label_blog_posts = en_label_blog_posts;

/** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */
const zh_label_blog_posts = en_label_blog_posts;

/** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */
const ar_label_blog_posts = en_label_blog_posts;

/** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */
const it_label_blog_posts = en_label_blog_posts;

/** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */
const ru_label_blog_posts = en_label_blog_posts;

/** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */
const pt_label_blog_posts = en_label_blog_posts;

/** @type {(inputs: Label_Blog_PostsInputs) => LocalizedString} */
const ko_label_blog_posts = en_label_blog_posts;

/**
* | output |
* | --- |
* | "Updates & Feed" |
*
* @param {Label_Blog_PostsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_blog_posts = /** @type {((inputs?: Label_Blog_PostsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Blog_PostsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_blog_posts(inputs)
	if (locale === "es") return es_label_blog_posts(inputs)
	if (locale === "fr") return fr_label_blog_posts(inputs)
	if (locale === "de") return de_label_blog_posts(inputs)
	if (locale === "ja") return ja_label_blog_posts(inputs)
	if (locale === "zh") return zh_label_blog_posts(inputs)
	if (locale === "ar") return ar_label_blog_posts(inputs)
	if (locale === "id") return id_label_blog_posts(inputs)
	if (locale === "it") return it_label_blog_posts(inputs)
	if (locale === "ru") return ru_label_blog_posts(inputs)
	if (locale === "pt") return pt_label_blog_posts(inputs)
	return ko_label_blog_posts(inputs)
});